export class StorageCompany {
  id: number;
  name: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/StorageCompany.ts